import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { List, Map } from 'immutable'

import { Select } from 'antd'

import actions from '../../redux/productGroups/actions'

const { fetchProductGroups } = actions

const SelectProductGroup = ({
    onChange,
    value
}) => {
    const { i18n } = useTranslation('productGroups')
    const dispatch = useDispatch()
    const items = useSelector(state => state.getIn(['productGroups', 'items']) || new List()).toJS()
    const loading = useSelector(state => state.getIn(['productGroups', 'loading']) || false)
    const productGroupEntities = useSelector(state => state.getIn(['Entities', 'productGroups']) || new Map())
    const [innerValue, setInnerValue] = useState(undefined)

    useEffect(() => {
        dispatch(fetchProductGroups())
    }, [])

    useEffect(() => {
        if (value !== innerValue) { setInnerValue(value) }
    }, [value])

    const handleChange = (newValue) => {
        setInnerValue(newValue)
        onChange(newValue)
    }

    const onFilterOption = (input, option) => {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const renderOptions = () => {
        return items.map((id) => {
            const productGroup = productGroupEntities.get(id) || new Map()
            return (
                <Select.Option value={productGroup.get('id')}>
                    {productGroup.get(`name_${i18n.language}`)}
                </Select.Option>
            )
        })
    }

    return (
        <Select
            filterOption={onFilterOption}
            loading={loading}
            onChange={handleChange}
            placeholder={i18n.t('productGroups:selectProductGroup')}
            value={innerValue}
            style={{ width: '100%' }}
            showSearch>
            {renderOptions()}
        </Select>
    )
}

SelectProductGroup.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string
}

SelectProductGroup.defaultProps = {
    onChange: () => {}
}

export default SelectProductGroup
